import { SalesGroupInfo } from 'src/types';

export const getSalesGroup = (salesGroup: SalesGroupInfo) => {
  let salesGroupInfo = null;

  if (salesGroup) {
    salesGroupInfo = {
      'fields[COD_VEH_SALESGROUP]': salesGroup.salesGroupId,
      'fields[DESC_VEH_SALESGROUP]': salesGroup.salesGroupName,
    };
  }
  return salesGroupInfo;
};

